import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Betrycia-Regular';
    src: url('/fonts/Betrycia-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Texta';
    src: url('/fonts/Texta.ttf') format('truetype');
  }

  :root {
    --primary-yellow: #E1B457;
    --primary-purple: #2B1D24;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    color: var(--primary-purple);
    background-color: #fff;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  }

  /* Global animations */
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }

  /* New directional animations */
  @keyframes fadeLeft {
    from { opacity: 0; transform: translateX(-12px); }
    to { opacity: 1; transform: translateX(0); }
  }

  @keyframes fadeRight {
    from { opacity: 0; transform: translateX(12px); }
    to { opacity: 1; transform: translateX(0); }
  }

  @keyframes fadeDown {
    from { opacity: 0; transform: translateY(-12px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes zoomIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }

  @keyframes float {
    0% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
    100% { transform: translateY(0); }
  }

  /* Click feedback */
  @keyframes clickBounce {
    0% { transform: scale(1); }
    30% { transform: scale(0.96); }
    60% { transform: scale(1.04); }
    100% { transform: scale(1); }
  }

  @keyframes slideLeft {
    from { opacity: 0; transform: translateX(24px); }
    to { opacity: 1; transform: translateX(0); }
  }

  @keyframes slideRight {
    from { opacity: 0; transform: translateX(-24px); }
    to { opacity: 1; transform: translateX(0); }
  }

  @keyframes slideUp {
    from { opacity: 0; transform: translateY(24px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-24px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes popIn {
    0% { opacity: 0; transform: scale(0.92); }
    60% { opacity: 1; transform: scale(1.04); }
    100% { transform: scale(1); }
  }

  @keyframes bounceIn {
    0% { opacity: 0; transform: translateY(18px) scale(0.96); }
    50% { opacity: 1; transform: translateY(-6px) scale(1.05); }
    100% { transform: translateY(0) scale(1); }
  }
  .animate-fadeIn { animation: fadeIn 0.8s ease both; }
  .animate-fadeUp { animation: fadeUp 0.8s ease both; }
  .animate-float { animation: float 6s ease-in-out infinite; }
  .click-bounce { animation: clickBounce 300ms ease; }
  .animate-zoomIn { animation: zoomIn 0.6s ease both; }
  .animate-fadeDown { animation: fadeDown 0.6s ease both; }

  /* Scroll reveal helpers */
  [data-reveal] { opacity: 0; }

  /* Initial offsets by direction */
  [data-reveal="up"], [data-reveal="bottom"] { transform: translateY(12px); }
  [data-reveal="down"] { transform: translateY(-12px); }
  [data-reveal="left"] { transform: translateX(-12px); }
  [data-reveal="right"] { transform: translateX(12px); }
  [data-reveal="zoom"] { transform: scale(0.95); }

  /* Reveal animations by direction. Default is fadeUp */
  .revealed { animation: fadeUp 0.8s ease both; }
  [data-reveal="left"].revealed { animation: fadeLeft 0.8s ease both; }
  [data-reveal="right"].revealed { animation: fadeRight 0.8s ease both; }
  [data-reveal="down"].revealed { animation: fadeDown 0.8s ease both; }
  [data-reveal="up"].revealed, [data-reveal="bottom"].revealed { animation: fadeUp 0.8s ease both; }
  [data-reveal="zoom"].revealed { animation: zoomIn 0.6s ease both; }

  /* Buttons - subtle hover transitions */
  .btn-primary,
  a[data-btn="primary"] {
    display: inline-block;
    background-color: var(--primary-purple);
    color: white;
    padding: 0.8rem 1.5rem;
    border-radius: 30px;
    text-decoration: none;
    font-weight: 600;
    transition: background-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
    will-change: transform;
  }
  .btn-primary:hover,
  a[data-btn="primary"]:hover {
    background-color: #1a1116;
    box-shadow: 0 8px 20px rgba(43, 29, 36, 0.15);
    transform: translateY(-3px);
  }

  /* Respect users with motion sensitivity */
  @media (prefers-reduced-motion: reduce) {
    .animate-fadeIn,
    .animate-fadeUp,
    .animate-zoomIn,
    .animate-fadeDown,
    .animate-slideLeft,
    .animate-slideRight,
    .animate-slideUp,
    .animate-slideDown,
    .animate-popIn,
    .animate-bounceIn,
    .revealed,
    [data-reveal] {
      animation: none !important;
      transform: none !important;
    }
    .btn-primary,
    a[data-btn="primary"],
    .hover-lift,
    .hover-pop,
    .hover-bounce,
    a,
    button {
      transition: none !important;
    }
  }
`;